// extracted by mini-css-extract-plugin
export default {"download":"UlEIm","failureListTable":"xsNl_"};